const ROUTES = {
  ORGANIZATIONS: "/organizations",
  LOCATIONS_DASHBOARD: "/locations-dashboard",
};

export default ROUTES;
